import React from 'react';
import { branding } from '../mock';
import '../styles/print.css';

const PrintPage = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="print-container">
      <div className="print-content">
        {/* Header */}
        <header className="print-header">
          <div className="print-logos">
            <img 
              src="https://customer-assets.emergentagent.com/job_wne-connects/artifacts/eu18fa7y_CEEF%20Logo%20V4%20Seal%20WHT.png" 
              alt="CEEF Logo" 
              className="print-logo-img"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_wne-connects/artifacts/ctlv6xd5_CEE%20LLC%20Logo%20V4%20WHT.png" 
              alt="CEE LLC Logo" 
              className="print-logo-img"
            />
          </div>
          <h1 className="print-title">{branding.title} Links</h1>
          <p className="print-tagline">{branding.tagline}</p>
        </header>

        {/* QR Code */}
        <div className="qr-section">
          <div className="qr-placeholder">
            <img 
              src="/qr/master-wne-qr.png" 
              alt="WNE QR Code" 
              width="300" 
              height="300"
              style={{ display: 'block' }}
            />
          </div>
          <p className="qr-caption">Scan for film, report & contacts</p>
          <p className="qr-url">{branding.vanityUrl}</p>
        </div>

        {/* Quick Links Text */}
        <div className="quick-links">
          <h2>Quick Access:</h2>
          <ul>
            <li>Watch CEEF Film</li>
            <li>Read Nuclear Energy Dominance Report</li>
            <li>Visit CEE LLC & CEEF Websites</li>
            <li>Contact Information</li>
          </ul>
        </div>

        {/* Print Button (hidden when printing) */}
        <button className="print-btn no-print" onClick={handlePrint}>
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default PrintPage;
